module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "width": "700px"
    },
    on: {
      "on-ok": _vm.addStageReport
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "reportForm",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.reportRules
    }
  }, [_c('div', {
    staticClass: "evaluation"
  }, [_c('h3', [_vm._v("Periodical Evaluation Sheet")]), _vm._v(" "), _c('div', {
    staticClass: "pd10 border-btm"
  }, [_vm._v("\n        Congratulations to " + _vm._s(_vm.name) + " for having successfully completed the study of\n        "), _c('Select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "prop": "lessonNum"
    },
    model: {
      value: (_vm.formData.lessonNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lessonNum", $$v)
      },
      expression: "formData.lessonNum"
    }
  }, [_c('Option', {
    attrs: {
      "value": 20
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 40
    }
  }, [_vm._v("40")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 60
    }
  }, [_vm._v("60")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 80
    }
  }, [_vm._v("80")])], 1), _vm._v(" lessons\n      ")], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Part 1: Vocabulary and key language points:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        (minimum 20 key words and 10 key sentences)\n      ")]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "partOneVocabulary"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Enter something...",
      "prop": "partOneVocabulary"
    },
    model: {
      value: (_vm.formData.partOneVocabulary),
      callback: function($$v) {
        _vm.$set(_vm.formData, "partOneVocabulary", $$v)
      },
      expression: "formData.partOneVocabulary"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Part 2: Ability for use\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        1. Speaking\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        To see if the student speaks like native speakers.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        1). Intonation\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        2). Speech fluency\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        3). Pronunciation accuracy\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        4). Speaking pace\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        Please write your comments from the above four aspects (at least 20 words):\n      ")]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "partTwoSpeaking"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Enter something...",
      "prop": "partTwoSpeaking"
    },
    model: {
      value: (_vm.formData.partTwoSpeaking),
      callback: function($$v) {
        _vm.$set(_vm.formData, "partTwoSpeaking", $$v)
      },
      expression: "formData.partTwoSpeaking"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        2. Listening\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        To see if the student can understand and follow the teacher’s instructions or modelling.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        Please write your comments according to the above criteria (at least 20 words):\n      ")]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "partTwoListening"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Enter something...",
      "prop": "partTwoListening"
    },
    model: {
      value: (_vm.formData.partTwoListening),
      callback: function($$v) {
        _vm.$set(_vm.formData, "partTwoListening", $$v)
      },
      expression: "formData.partTwoListening"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        3. Usage of Sentences\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        To see if the student can use complete sentences, or better, compound sentences.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        1). Comprehension of the sentences.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        2). Output of complete sentences.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        3). Clarity of expression\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        4). Grammatical accuracy\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        Please write your comments from the above four aspects (at least 20 words):\n      ")]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "partTwoSentences"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Enter something...",
      "prop": "partTwoSentences"
    },
    model: {
      value: (_vm.formData.partTwoSentences),
      callback: function($$v) {
        _vm.$set(_vm.formData, "partTwoSentences", $$v)
      },
      expression: "formData.partTwoSentences"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        4. Adaptability\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        To see if the student can adapt to an English only class quickly and feels comfortable.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        1). If the student actively speaks in classes.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        2). If the interaction between the student and the tutor is natural and comfortable.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        3). If the student can follow the classroom rules.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        Please write your comments from the above three aspects (at least 20 words):\n      ")]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "partTwoAdaptability"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Enter something...",
      "prop": "partTwoAdaptability"
    },
    model: {
      value: (_vm.formData.partTwoAdaptability),
      callback: function($$v) {
        _vm.$set(_vm.formData, "partTwoAdaptability", $$v)
      },
      expression: "formData.partTwoAdaptability"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        5. Interaction with the teacher\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        To see if the student can respond to the teacher, whether verbally or using body language.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        Please write your comments according to the above criteria (at least 20 words):\n      ")]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "partTwoInteraction"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Enter something...",
      "prop": "partTwoInteraction"
    },
    model: {
      value: (_vm.formData.partTwoInteraction),
      callback: function($$v) {
        _vm.$set(_vm.formData, "partTwoInteraction", $$v)
      },
      expression: "formData.partTwoInteraction"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Part 3: Teacher’s comments (at least 25 words)\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        Comments that the tutor will give (it should include at least two parts: Suggestions about English learning , comments and suggestions about classroom behaviors)：\n      ")]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "partThreeComments"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Enter something...",
      "prop": "partThreeComments"
    },
    model: {
      value: (_vm.formData.partThreeComments),
      callback: function($$v) {
        _vm.$set(_vm.formData, "partThreeComments", $$v)
      },
      expression: "formData.partThreeComments"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Part 4: Tutor’s feedback about student’s English level\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v("\n        Tutor’s feedback about whether student English language ability suits for the current material level.\n      ")]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "partFourFeedback"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Enter something...",
      "prop": "partFourFeedback"
    },
    model: {
      value: (_vm.formData.partFourFeedback),
      callback: function($$v) {
        _vm.$set(_vm.formData, "partFourFeedback", $$v)
      },
      expression: "formData.partFourFeedback"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.addStageReport
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c3cee604","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/crm/EvaluationSheetModal.vue
// module id = 1948
// module chunks = 8